import Modal from "aldoo-ra/Modal"

export default function ShoppingCart({ store }) {
  //get the ProductComponent from the store
  //this is how we render the products in the cart
  //the project can override this component
  const { getFragment, cart, cartVisible, hideCart } = store
  // Modal look of the cart: config.modals.cart = { variant, className, styleOverrides }
  const modalConfig = store.config?.modals?.cart || {}

  //Fragments
  const EmptyCart = getFragment("shopping-cart-empty")
  const ShoppingCartProductList = getFragment("shopping-cart-product-list")
  const ShoppingCartFooter = getFragment("shopping-cart-footer")
  const ShoppingCartTitle = getFragment("shopping-cart-title")
  const ShoppingCartHeaderContent = getFragment("shopping-cart-header-content")

  if (!cartVisible) return null

  return (
    <Modal
      title={<ShoppingCartTitle store={store} />}
      isOpen={cartVisible}
      variant={modalConfig.variant || "aqua_big"}
      className={modalConfig.className ?? "md:max-w-[550px]"}
      styleOverrides={modalConfig.styleOverrides ?? {
        title: "mb-10 md:mb-0 mt-2 md:mt-0",
      }}
      closeOnEscape={!!modalConfig.closeOnEscape}
      onClose={hideCart}
      // headerContent={
      //   cart.length > 0 && <ShoppingCartHeaderContent store={store} />
      // }
    >
      <div data-testid="shopping-cart" className="h-full">
        {/* Empty Cart */}
        {cart.length == 0 && <EmptyCart store={store} />}

        {cart.length > 0 && (
          <div
            className="max-w-[520px] md:max-w-full h-full flex flex-col justify-between mx-auto md:mx-0"
          >
            <ShoppingCartProductList store={store} />
            <ShoppingCartFooter store={store} />
          </div>
        )}
      </div>
    </Modal>
  )
}
